import { useCallback } from "react";
import useApiClient from "../services/axiosInstance";

export const useFinacialDetailsService = () => {
  const { api } = useApiClient();

  const saveFinacialDetail = useCallback(
    async ({ data }) => {
      try {
        const response = await api.post("/api/financial-details/save", data);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [api]
  );

  return { saveFinacialDetail };
};
